<div class="app">
   <router-outlet></router-outlet>
</div>
<aside class="right">
   <!-- ar (aside right) -->
   <router-outlet name="ar"></router-outlet>
</aside>
<div class="app-backdrop"></div>
